import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import { hasRole } from "@/js/http/auth.js";
export default {
  name: "adminUserRoles",
  data: function data() {
    return {
      idUser: "",
      fullNameUser: "",
      roles: "",
      datatable_headers: [{
        text: "Role name",
        align: "start",
        value: "name"
      }, {
        text: "Role description",
        align: "start",
        value: "description"
      }, {
        text: "Technical",
        align: "center",
        value: "id_role"
      }, {
        text: "Enabled",
        align: "center",
        value: "enabled"
      }],
      datatable_items: [],
      datatable_loading: true
    };
  },
  created: function created() {
    var _this$$route$query;
    //We need those parameter : gotolist otherwise
    if (!((_this$$route$query = this.$route.query) !== null && _this$$route$query !== void 0 && _this$$route$query.id_user)) {
      this.$router.push({
        name: "adminUserList"
      });
    }
    this.datatable_loading = true;
    document.body.style.cursor = "wait";
    this.idUser = this.$route.query.id_user;
    this.fullNameUser = this.$route.params.fullname;
    var _this = this;
    request("/v1/user/roles/" + _this.idUser, "get", null, true, "api").then(function (response) {
      //Reset datatable datas
      _this.datatable_items = [];

      //Creating datatable datas
      response.data.forEach(function (role) {
        _this.datatable_items.push({
          id_role: role.id_role,
          name: role.label,
          description: role.description,
          enabled: role.role_user
        });
      });
      _this.datatable_items.sort(function (a, b) {
        return a.enabled < b.enabled ? 1 : -1;
      });

      //We keep an array of the current roles of user
      _this.roles = response.data;

      //Finished loading
      _this.datatable_loading = false;
      document.body.style.cursor = "default";
    }).catch(function (err) {
      _this.$toasted.show("An error occured. Please contact an administrator.", {
        type: "error"
      });
      document.body.style.cursor = "default";
    });
  },
  methods: {
    canManage: function canManage() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_USER_ROLES);
    },
    goToUserDetails: function goToUserDetails() {
      this.$router.push({
        name: "adminUserDetails",
        query: {
          id_user: this.idUser
        }
      });
    },
    validateRoles: function validateRoles() {
      var _this = this;
      document.body.style.cursor = "wait";
      request("/v1/user/roles/" + _this.idUser, "put", _this.roles, true, "api").then(function (response) {
        _this.$toasted.show("User roles updated.", {
          type: "success"
        });
        document.body.style.cursor = "default";
      }).catch(function (err) {
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
        document.body.style.cursor = "default";
      });
    },
    roleChange: function roleChange(item_role, enabled) {
      for (var i = 0; i < this.roles.length; i++) {
        if (this.roles[i].id_role === item_role.id_role) {
          this.roles[i].role_user = enabled;
        }
      }
      item_role.enabled = enabled;
    }
  }
};